import { Worksheet } from "exceljs";

import {
  ChildWorksheet,
  HyperlinkMetadata,
} from "../../../../types/types.export";

export const applyHyperlinks = (
  parentWorksheet: Worksheet,
  hyperlinks: HyperlinkMetadata[],
  childSheets: ChildWorksheet[],
): void => {
  hyperlinks.forEach((link) => {
    if (link.childCount === 0) {
      return;
    }

    const childSheet = childSheets.find(
      (sheet) => sheet.field === link.childField,
    );

    if (!childSheet) {
      return;
    }

    const childRow = childSheet.firstRowMap.get(link.parentIdentifier);

    if (!childRow) {
      return;
    }

    const columnNumber = getColumnNumber(parentWorksheet, link.columnTitle);

    if (columnNumber === -1) {
      return;
    }

    const cell = parentWorksheet.getCell(link.parentRowIndex, columnNumber);

    cell.value = {
      text: `View (${link.childCount})`,
      hyperlink: `#'${childSheet.sheetName}'!A${childRow}`,
    };

    cell.font = {
      color: {
        argb: "0563C1",
      },
      underline: true,
    };
  });
};

const getColumnNumber = (worksheet: Worksheet, columnTitle: string): number => {
  const headerRow = worksheet.getRow(1);

  for (let column = 1; column <= headerRow.cellCount; column++) {
    if (headerRow.getCell(column).text === columnTitle) {
      return column;
    }
  }

  return -1;
};
